document.addEventListener('DOMContentLoaded', function() {
  var cards = document.querySelectorAll('.pau-flip-card');
  cards.forEach(function(card) {
    card.addEventListener('click', function(e) {
      if (e.target.tagName === 'A') return;
      card.classList.toggle('is-flipped');
    });
    card.addEventListener('keydown', function(e) {
      if (e.key === 'Enter' || e.key === ' ') {
        e.preventDefault();
        card.classList.toggle('is-flipped');
      }
    });
  });
});